<template>
  <span
    class="file-loader-type-text"
    :aria-label="`File type: ${fileType}`"
  >
    {{ displayText }}
  </span>
</template>

<script lang="ts">
import Vue from 'vue'

const displayTextMap: Record<string, string> = {
  'Contacts & Preferences': 'Contacts & Preferences',
  'Delete': 'Delete',
  'RTBF': 'RTBF',
  'Merge': 'Merge'
}

export default Vue.extend({
  name: 'FileLoaderTypeBadge',

  props: {
    /** File type: 'Contacts & Preferences' | 'Delete' | 'RTBF' | 'Merge' */
    fileType: {
      type: String as () => 'Contacts & Preferences' | 'Delete' | 'RTBF' | 'Merge',
      required: true,
      validator: (value: string) =>
        ['Contacts & Preferences', 'Delete', 'RTBF', 'Merge'].includes(value)
    }
  },

  computed: {
    displayText(): string {
      return displayTextMap[this.fileType] || this.fileType
    }
  }
})
</script>

<style scoped>
.file-loader-type-text {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--muted-foreground);
  line-height: 1.3;
  display: block;
  text-align: center;
}
</style>
